'use strict';
'use es6';

// These should be removed once we have 100% adoption of UIApplication

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

require('../listeners/focusStylesListener');

var _setupStyledComponents = require('../listeners/setupStyledComponents');

var _I18n = require('I18n');

var _I18n2 = _interopRequireDefault(_I18n);

var _reactAddonsPureRenderMixin = require('react-addons-pure-render-mixin');

var _reactAddonsPureRenderMixin2 = _interopRequireDefault(_reactAddonsPureRenderMixin);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classNames = require('react-utils/classNames');

var _classNames2 = _interopRequireDefault(_classNames);

var _devLogger = require('react-utils/devLogger');

var _devLogger2 = _interopRequireDefault(_devLogger);

var _Functions = require('../core/Functions');

var _UnsafeUrl = require('../utils/UnsafeUrl');

var _Links = require('../utils/Links');

var _TabIndex = require('../utils/TabIndex');

var _HoverProvider = require('../providers/HoverProvider');

var _HoverProvider2 = _interopRequireDefault(_HoverProvider);

var _ShareButton = require('../decorators/ShareButton');

var _ShareButton2 = _interopRequireDefault(_ShareButton);

var _validHref = require('../utils/propTypes/validHref');

var _validHref2 = _interopRequireDefault(_validHref);

var _refObject = require('../utils/propTypes/refObject');

var _refObject2 = _interopRequireDefault(_refObject);

var _tshirtSize = require('../utils/propTypes/tshirtSize');

var TShirtSize = _interopRequireWildcard(_tshirtSize);

var _UITruncateString = require('../text/UITruncateString');

var _UITruncateString2 = _interopRequireDefault(_UITruncateString);

var _UIClickable = require('./UIClickable');

var _UIClickable2 = _interopRequireDefault(_UIClickable);

var _UIIcon = require('../icon/UIIcon');

var _UIIcon2 = _interopRequireDefault(_UIIcon);

var _ButtonConstants = require('../button/ButtonConstants');

var _ActiveProvider = require('../providers/ActiveProvider');

var _ActiveProvider2 = _interopRequireDefault(_ActiveProvider);

var _ClickableContext = require('../context/ClickableContext');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

(0, _setupStyledComponents.setupStyledComponents)();

var getClassName = function getClassName(active, block, className, disabled, hovered, responsive, computedSize, computedUse) {
  var unstyled = computedUse === 'unstyled';
  return (0, _classNames2.default)('uiButton', 'private-button', _ButtonConstants.SIZE_CLASSES[computedSize] || _ButtonConstants.SIZE_CLASSES.default, _ButtonConstants.USE_CLASSES[computedUse], className, {
    'private-button--active': active && !unstyled,
    'private-button--block': block && !unstyled,
    'disabled private-button--disabled': disabled && !unstyled,
    'private-button--non-responsive': !responsive,
    'private-button--non-link': _ButtonConstants.LINK_USES.indexOf(computedUse) === -1,
    'private-button--hover': hovered
  });
};

var getUse = function getUse(use) {
  return use && _ButtonConstants.USE_CLASSES[use] ? use : 'secondary';
};

var renderContents = function renderContents(children) {
  var stringBuffer = '';
  var nextChildIndex = 0;
  var childArr = _react.Children.toArray(children);
  return _react.Children.map(children, function (child) {
    nextChildIndex += 1;
    if (child == null) {
      return null;
    }

    // in response to a breaking change in React 0.15
    // (https://facebook.github.io/react/blog/2016/04/07/react-v15.html#no-more-extra-ltspangts)
    // this wraps any bare strings within a <span> to provide a more
    // predictable DOM for applying automatic spacing rules.
    if (typeof child === 'string') {
      stringBuffer += child;
      if (childArr.length < nextChildIndex || typeof childArr[nextChildIndex] !== 'string') {
        var wrappedStringBuffer = _react2.default.createElement(
          'span',
          null,
          stringBuffer
        );
        stringBuffer = '';
        return wrappedStringBuffer;
      } else {
        return null;
      }
    }

    return child;
  });
};

var renderExternalButtonIcon = function renderExternalButtonIcon(external, iconProps) {
  if (!external) return null;

  // Opening links in a new window is an accessibility anti-pattern.
  // To mitigate this, we add accessible text in the icon to warn that
  // the link will be opened in a new window
  // @link http://diveintoaccessibility.info/day_16_not_opening_new_windows.html

  return _react2.default.createElement(_UIIcon2.default, _extends({}, iconProps, {
    'aria-label': _I18n2.default.text('salesUI.UILink.externalTitle'),
    className: iconProps.className || 'private-link--external__icon',
    name: 'externalLink'
  }));
};

var renderTruncatedContents = function renderTruncatedContents(truncate, truncateStringProps, renderedContents, renderedExternalButtonIcon) {
  return truncate ? _react2.default.createElement(
    _UITruncateString2.default,
    _extends({
      innerClassName: 'private-button__truncate-string',
      useFlex: true,
      fixedChildren: renderedExternalButtonIcon
    }, truncateStringProps),
    _react2.default.createElement(
      'span',
      null,
      renderedContents
    )
  ) : renderedContents;
};

var validateProps = function validateProps(external, size, use, computedTarget) {
  (0, _Links.warnIfShouldBeExternal)(external, computedTarget, 'UIButton');

  if (use === 'form' && size !== 'default') {
    _devLogger2.default.warn({
      message: 'UIButton: size="' + size + '" is not supported with use="form"',
      key: 'UIButton: form size'
    });
  }
};

var UIButton = _react2.default.createClass({
  displayName: 'UIButton',

  mixins: [_reactAddonsPureRenderMixin2.default],

  componentDidMount: function componentDidMount() {
    var _props = this.props,
        autoFocus = _props.autoFocus,
        buttonRef = _props.buttonRef,
        href = _props.href;

    if (autoFocus && href) {
      if (buttonRef.current) buttonRef.current.focus();
    }
  },
  handleMouseDown: function handleMouseDown(evt) {
    var onMouseDown = this.props.onMouseDown;


    if (this.props.disabled) {
      evt.stopPropagation();
    }

    (0, _Functions.callIfPossible)(onMouseDown, evt);
  },
  handleLinkKeyDown: function handleLinkKeyDown(evt) {
    // Simulate click on Spacebar, to emulate button behavior
    var key = evt.key;
    var _props2 = this.props,
        disabled = _props2.disabled,
        onKeyDown = _props2.onKeyDown,
        onClick = _props2.onClick;


    (0, _Functions.callIfPossible)(onKeyDown, evt);

    if (typeof onClick !== 'function') {
      return;
    }

    if (key === ' ') {
      if (disabled) {
        evt.preventDefault();
        evt.stopPropagation();
        return;
      }
      onClick(evt);

      // Prevent scrolling
      evt.preventDefault();
    }
  },
  handleClick: function handleClick(evt) {
    var onClick = this.props.onClick;

    if (this.props.disabled) {
      evt.preventDefault();
      evt.stopPropagation();
    } else {
      (0, _Functions.callIfPossible)(onClick, evt);
    }
  },
  render: function render() {
    var _props3 = this.props,
        _useNativeButton = _props3._useNativeButton,
        active = _props3.active,
        ariaPressed = _props3['aria-pressed'],
        block = _props3.block,
        buttonRef = _props3.buttonRef,
        children = _props3.children,
        className = _props3.className,
        disabled = _props3.disabled,
        external = _props3.external,
        hovered = _props3.hovered,
        href = _props3.href,
        iconProps = _props3.iconProps,
        __onClick = _props3.onClick,
        __onMouseDown = _props3.onMouseDown,
        rel = _props3.rel,
        responsive = _props3.responsive,
        size = _props3.size,
        tabIndex = _props3.tabIndex,
        target = _props3.target,
        truncate = _props3.truncate,
        truncateStringProps = _props3.truncateStringProps,
        use = _props3.use,
        rest = _objectWithoutProperties(_props3, ['_useNativeButton', 'active', 'aria-pressed', 'block', 'buttonRef', 'children', 'className', 'disabled', 'external', 'hovered', 'href', 'iconProps', 'onClick', 'onMouseDown', 'rel', 'responsive', 'size', 'tabIndex', 'target', 'truncate', 'truncateStringProps', 'use']);

    var computedSize = TShirtSize.fromProp(size).long;
    var computedTabIndex = (0, _TabIndex.getTabIndex)(disabled, tabIndex);
    var computedTarget = (0, _Links.getTarget)(external, target);
    var computedUse = getUse(use);

    validateProps(external, size, use, computedTarget);

    var renderedContents = renderContents(children);

    var renderedExternalButtonIcon = renderExternalButtonIcon(external, iconProps);
    var wrappedContents = renderTruncatedContents(truncate, truncateStringProps, renderedContents, renderedExternalButtonIcon);

    var computedClassName = getClassName(active, block, className, disabled, hovered, responsive, computedSize, computedUse);

    var commonProps = {
      'aria-disabled': disabled,
      className: computedClassName,
      'data-button-use': computedUse,
      onClick: this.handleClick,
      onMouseDown: this.handleMouseDown,
      ref: (0, _Functions.wrapRefObject)(buttonRef),
      tabIndex: computedTabIndex
    };

    if (href) {
      var computedRel = (0, _Links.getRel)(rel, computedTarget);
      return (0, _Links.renderSecurityTaggedLink)(href, _react2.default.createElement(
        'a',
        _extends({}, rest, commonProps, {
          onKeyDown: this.handleLinkKeyDown,
          href: (0, _UnsafeUrl.getSafeUrl)(href),
          rel: computedRel,
          target: computedTarget
        }),
        wrappedContents,
        truncate ? null : renderedExternalButtonIcon
      ));
    }

    var ButtonComponent = _useNativeButton ? 'button' : _UIClickable2.default;

    if (!_useNativeButton) {
      // Pass buttonRef down directly to the UIClickable
      commonProps.buttonRef = buttonRef;
      delete commonProps.ref;
    }

    return _react2.default.createElement(
      ButtonComponent,
      _extends({}, rest, commonProps, {
        'aria-pressed': ariaPressed != null ? ariaPressed : active || undefined,
        disabled: _useNativeButton ? undefined : disabled
      }),
      wrappedContents
    );
  }
});

UIButton.displayName = 'UIButton';

var UIButtonWithProviders = function (_React$Component) {
  _inherits(UIButtonWithProviders, _React$Component);

  function UIButtonWithProviders(props) {
    _classCallCheck(this, UIButtonWithProviders);

    var _this = _possibleConstructorReturn(this, (UIButtonWithProviders.__proto__ || Object.getPrototypeOf(UIButtonWithProviders)).call(this, props));

    _this.getPortalReporterDetails = _this.getPortalReporterDetails.bind(_this);
    return _this;
  }

  _createClass(UIButtonWithProviders, [{
    key: 'getPortalReporterDetails',
    value: function getPortalReporterDetails() {
      var buttonRef = this.props.buttonRef;

      var buttonEl = buttonRef.current;
      return {
        componentName: UIButton.displayName,
        labelText: buttonEl && buttonEl.innerText
      };
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      return _react2.default.createElement(
        _ClickableContext.ClickableContextProvider,
        {
          value: (0, _ClickableContext.makePortalReporter)(this.getPortalReporterDetails)
        },
        _react2.default.createElement(
          _ActiveProvider2.default,
          this.props,
          function (activeProviderProps) {
            return _react2.default.createElement(
              _HoverProvider2.default,
              _this2.props,
              function (hoverProviderProps) {
                return _react2.default.createElement(UIButton, _extends({}, _this2.props, activeProviderProps, hoverProviderProps));
              }
            );
          }
        )
      );
    }
  }]);

  return UIButtonWithProviders;
}(_react2.default.Component);

UIButtonWithProviders.propTypes = {
  _useNativeButton: _react.PropTypes.bool,
  active: _react.PropTypes.bool,
  autoFocus: _react.PropTypes.bool,
  'aria-pressed': _react.PropTypes.bool,
  block: _react.PropTypes.bool,
  buttonRef: _refObject2.default,
  children: _react.PropTypes.node,
  disabled: _react.PropTypes.bool.isRequired,
  external: _react.PropTypes.bool.isRequired,
  href: _validHref2.default,
  hovered: _react.PropTypes.bool,
  iconProps: _react.PropTypes.object.isRequired,
  responsive: _react.PropTypes.bool.isRequired,
  rel: _react.PropTypes.string,
  size: TShirtSize.propTypeForSizes(['xs', 'sm', 'md'], ['default']),
  target: _react.PropTypes.string,
  truncate: _react.PropTypes.bool.isRequired,
  truncateStringProps: _react.PropTypes.object.isRequired,
  type: _react.PropTypes.oneOf(['button', 'reset', 'submit']).isRequired,
  use: _react.PropTypes.oneOf(Object.keys(_ButtonConstants.USE_CLASSES)).isRequired
};

UIButtonWithProviders.defaultProps = {
  _useNativeButton: true,
  disabled: false,
  external: false,
  iconProps: {},
  responsive: true,
  size: 'medium',
  truncate: false,
  truncateStringProps: {},
  type: 'button',
  use: 'secondary'
};

// Expose the core component for tests
UIButtonWithProviders.WrappedComponent = UIButton;
UIButtonWithProviders.CoreComponent = UIButton;

UIButtonWithProviders.displayName = 'UIButtonWithProviders';

exports.default = (0, _ShareButton2.default)(UIButtonWithProviders);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.2750/js/button/UIButton.js
// module id = 22
// module chunks = 171